/**
 * 判断是否是生产环境
 */
export function isProduct() {
  return process.env.BACKEND_ENV === "production";
}
